import Layout from "@components/Layout"
import RadioInputButton from "@components/RadioInputButton"
import { useTranslation } from "react-i18next"
import { Form, useSubmit } from "react-router-dom"

export default function RefocusTimePage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    submit(event.currentTarget.form)
  }

  return (
    <Layout>
      <div className="shrink-0">
        <h1 className="custom-heading">
          {t("pages.onboardingV2.refocusTime.heading")}
        </h1>
      </div>

      <Form className="flex grow flex-col justify-center gap-5" method="post">
        <RadioInputButton
          className="from-pd-yellow"
          emoji="⏱️"
          label={t("pages.onboardingV2.refocusTime.minutes")}
          name={t("pages.onboardingV2.refocusTime.heading", {
            lng: "en",
          })}
          onChange={handleChange}
          value={t("pages.onboardingV2.refocusTime.minutes", {
            lng: "en",
          })}
        />

        <RadioInputButton
          className="from-pd-peach"
          emoji="🕒"
          label={t("pages.onboardingV2.refocusTime.hours")}
          name={t("pages.onboardingV2.refocusTime.heading", {
            lng: "en",
          })}
          onChange={handleChange}
          value={t("pages.onboardingV2.refocusTime.hours", {
            lng: "en",
          })}
        />

        <RadioInputButton
          className="from-pd-purple"
          emoji="🗓️"
          label={t("pages.onboardingV2.refocusTime.days")}
          name={t("pages.onboardingV2.refocusTime.heading", {
            lng: "en",
          })}
          onChange={handleChange}
          value={t("pages.onboardingV2.refocusTime.days", {
            lng: "en",
          })}
        />
      </Form>
    </Layout>
  )
}
